/**
 * Application entry point.
 *
 * Initializes the React application by rendering the root App component
 * into the DOM. This is the first file executed when the application loads.
 *
 * @module main
 */

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(<App />);

